import script from "./OTOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./OTOrder.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__